import { render, staticRenderFns } from "./BuildMatchups.vue?vue&type=template&id=17a3563c&"
import script from "./BuildMatchups.vue?vue&type=script&lang=js&"
export * from "./BuildMatchups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports